
  import ipxRuntime$bFhiiKbfKMKNOu6KuguYpljWs_Vqx0kp5_m4NlkqPhM from '/app/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_better-sqlite3@12.4.6__ioredis@5.8.2_magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs from '/app/app/image-provider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 768,
    "md": 1024,
    "lg": 1240,
    "xl": 1440,
    "2xl": 1536,
    "xs": 375,
    "xxl": 1920,
    "xxxl": 2560
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$bFhiiKbfKMKNOu6KuguYpljWs_Vqx0kp5_m4NlkqPhM, defaults: {"maxAge":31536000} },
  ['ipx']: { setup: ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs, defaults: undefined }
    }
  }
